import React from 'react';
import colors from '../../libs/colors';
import store from '../../store';
import styled from 'styled-components';


const badeg = {
    position: 'absolute',
    right: -15,
    top: -2,
    backgroundColor: colors.badgebg,
    borderRadius: 100,
    color: 'white',
    fontSize: 12,
    fontFamily: 'NSCJKrM',
    paddingLeft: 5,
    paddingRight: 5,
    margin: '0px 5px',
    lineHeight: '18px',
  };

  const badegV2 = {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: colors.badgebg,
    borderRadius: 100,
    color: 'white',
    fontSize: 12,
    fontFamily: 'NSCJKrM',
    padding: '0px 8px 1px 8px',
    lineHeight: '18px',
  };
//함수형 컴포넌트로 , 재사용성 늘리기
export const CartCountBadge = ({style=0,count, onClick, children }) =>{

    return (
        <div
        onClick={onClick}
        style={{ position: 'relative', display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
            {/* <badge>{count}</badge>  */}
            {style ===0?(
                    <div style={badeg}>{count.toLocaleString()}</div>
            ) : (
                <div style={badegV2}>{count.toLocaleString()}</div>
            )}
        
            {children}
        </div>
    )

}